import { breakpoints } from '@bnnvara/breakpoints';
import { BaseButton } from '@bnnvara/buttons';
import styled from 'styled-components';

export const NotificationContainer = styled.div`
  position: absolute;
  max-width: 575px;
  margin-top: 80px;

  ${breakpoints.md} {
    margin-top: 100px;
  }

  ${breakpoints.lg} {
    margin-top: 150px;
  }
`;

export const Button = styled(BaseButton)`
  color: ${({ theme }) => theme.base.white} !important;
  text-decoration: none !important;

  &:hover {
    color: ${({ theme }) => theme.base.black} !important;
  }
`;
